const selectors = {
    cartCheckout: document.querySelector('#cart-checkoutbtn'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};

class templateCartJS {
    constructor() {
        this.stickyCheckout();
        this.checkExtraShedExist();
        if (document.querySelector("[data-open-zip-code-popup]")) {
            document.querySelector("[data-open-zip-code-popup]").addEventListener("click" , (event)=>{
                this.openZipcodeValidator(event);
            })
            
        };

        if (document.querySelector("[data-zip]")) {
            document.querySelector('[data-zip]').addEventListener("click" , (event)=>{
              this.validateZipcode(event);
            })
            
          }
    }

    // Sticky checkout container on oage scroll
    stickyCheckout(){
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    selectors.checkoutSticky.classList.remove('active');
                } else {
                    selectors.checkoutSticky.classList.add('active');
                }
            })
        });
            
        observer.observe(selectors.cartCheckout);
    }

    checkExtraShedExist(){
        if (window.globalVariables.cart.items.length > 0) {
            let cartUpdatesArray= [];
            let shed_count = 0;
            let shedVariant = null;
            window.globalVariables.cart.items.forEach(item=>{
                if (item.properties && item.properties['_is_shed']) {
                  
                    if (shedVariant == null) {
                        shed_count = shed_count + 1;
                        shedVariant = item.id; 
                        
                    }else if(shedVariant != item.id){
                        shed_count = shed_count + 1;
                    }

                    
                }
            });

            if (shed_count > 1) {
                let shedCount = 0;
                window.globalVariables.cart.items.forEach(item=>{

                    if (item.properties && item.properties['_is_shed']) {
                        shedCount = shedCount + 1;
                        if (shedCount > 1) {
                            cartUpdatesArray.push({variant_id: `${item.id}`, quantity: 0})
                        }
                        
                    }else{
                        cartUpdatesArray.push({variant_id: `${item.id}`, quantity: 0})
                    }
                });
               this.updatedshedIncart(cartUpdatesArray)
                
            }
            
           }
 
    }

    updatedshedIncart(cartUpdatesArray){
        // Convert the array of objects into a single object with variant IDs as keys
      const updates = cartUpdatesArray.reduce((acc, item) => {  acc[item.variant_id] = item.quantity;   return acc;}, {});
      // Make the API call to update the cart
       fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ updates: updates }),
      })
        .then(response => response.json())
        .then(_state => {
          window.location.reload()
         })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
  
    }

    openZipcodeValidator(event){
        event.preventDefault();
        document.querySelector("#zip-code-popup .modal").classList.add("open");
        siteOverlay.prototype.showOverlay();

    }


    validateZipcode(event){
        let current_ele = event.currentTarget;
        current_ele.setAttribute('disabled', true);
        current_ele.classList.add('loading');
        let zipcode = document.querySelector("[zip-value]").value;
        zipcode = zipcode.trim();
    
        if(zipcode == ''){
          window.notificationEle.updateNotification('Zip Code', "Please enter a zipcode", {
            type: 'error',
            timeout: 5000
        });
        document.querySelector("[zip-value]").value='';
        current_ele.removeAttribute('disabled');
        current_ele.classList.remove('loading');
        return
    
        }else{
          window.globalVariables.zipcode = zipcode;
    
    
          fetch('https://dev.bypboh.com/api/zipcode', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "postal_code": `${zipcode}`,
              "brand": "Shed Liquidators"
            })
          })
          .then(response => response.json())
          .then(response=>{
           
            if (response.status == false) {
              document.querySelectorAll(".modal").forEach(ele=>{
                ele.classList.remove("open");
              });
              siteOverlay.prototype.hideOverlay();
              window.notificationEle.updateNotification('Error', "Sorry, installation is not available in your area.", {
                type: 'error',
                timeout: 10000
              });
              if(document.querySelector("[data-checkout-btn]")) document.querySelector("[data-checkout-btn]").classList.add("disabled");
              current_ele.removeAttribute('disabled');
              current_ele.classList.remove('loading');
            }else{
              let shedProductData = window.globalVariables.cart.items.find(item => item.properties['_is_shed']);
              let mainProductData = JSON.parse(document.querySelector("[florida-product-data]").innerText);            
              mainProductData = mainProductData.find(x=> x.variant_id ==shedProductData.id);
              if (!shedProductData) {
                window.location.href='/cart/clear'
              }   
            else if (response.distribution_center_state == 'FL' && mainProductData.is_available_in_florida == "false") {
            window.notificationEle.updateNotification('Error', "Due to strict building codes, this shed is not available in Florida. Check our selection of sheds built with 2x4 construction to find a shed compatible in Florida.", {
                type: 'error',
                timeout: 45000
            });
            if(document.querySelector("[data-checkout-btn]")) document.querySelector("[data-checkout-btn]").classList.add("disabled");
            current_ele.removeAttribute('disabled');
            current_ele.classList.remove('loading');
            if (document.querySelectorAll(".modal").length > 0) {
                document.querySelectorAll(".modal").forEach(ele=>{ele.classList.remove("open")});
            }
            siteOverlay.prototype.hideOverlay();
            
            return
            }else{
               if (response.distribution_center_state == 'FL') {
                const newProperties = {
                    _is_shed:"true",
                    _florida_price: `${mainProductData.florida_price}`,
                    _zip_code: `${zipcode}`,
                    _province: `${response.distribution_center_state}`
                };
                AjaxCart.prototype.updateLineItemPropertiesByVariantId(shedProductData.key, newProperties);
               }else{
                const newProperties = {
                    _is_shed:"true",
                    _zip_code: `${zipcode}`,
                    _province: `${response.distribution_center_state}`
                };
                AjaxCart.prototype.updateLineItemPropertiesByVariantId(shedProductData.key, newProperties);
               }
            
           
           
            }
        }
            
        }).catch((e) => {
        window.notificationEle.updateNotification('Error', "Sorry, installation is not available in your area.", {
            type: 'error',
            timeout: 5000
        });
        current_ele.classList.remove('loading');
        current_ele.removeAttribute('disabled');
        
        if (document.querySelectorAll(".modal").length > 0) {
            document.querySelectorAll(".modal").forEach(ele=>{ele.classList.remove("open")});
        }
        document.querySelector("#site-overlay").classList.remove("overlay--body");
        document.body.classList.remove("scroll-fixed");
        console.error(e);
        })
        .finally(() => {
        current_ele.classList.remove('loading');
        current_ele.removeAttribute('disabled');
        // if (document.querySelectorAll(".modal").length > 0) {
        //   document.querySelectorAll(".modal").forEach(ele=>{ele.classList.remove("open")});
        // }
        // document.querySelector("#site-overlay").classList.add("overlay--body");
        // document.body.classList.add("scroll-fixed");
        });
        
        document.querySelector("[zip-value]").value='';
        }
    }

    updateLineItemPropertiesByVariantId(lineItemKey, newProperties) {

        const data = {
            id: lineItemKey, // Use the line item key
            properties: newProperties
        };

        // Send the AJAX request to update the line item properties
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to update line item properties');
            }
            return response.json();
        })
        .then(_state => {
            console.log('Updated cart:', _state);
            let dataJSON = ((typeof _state == 'object') ? _state : JSON.parse(_state));
            // Optionally, refresh the cart UI or take other actions
            AjaxCart.prototype.getCartData('open drawer');
        })
        .catch(error => {
            console.error('Error updating line item properties:', error);
        });
   
    } 
}

typeof templateCartJS !== 'undefined' && new templateCartJS();
